export default __webpack_public_path__ + "static/media/light-active.40d58b2d.png";